/* @ngInject */
const format = () => {
  const self = {}

  self.user = (_area) => {
    return _area
  }
  self.server = (_area) => {
    return _area
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/format.service.js